import { showErrorToUser } from '@pletly/ui';
import { useRefreshControl } from '%components/ListDefaultLayout/useRefreshControl';
import { GroupsList } from '../components/GroupsList';
import {
	PublicCommunityGroupsDocument,
	usePublicCommunityGroupsQuery,
} from './components/__generated__/publicGroups.generated';
import { useSendJoinCommunityRequestMutation } from './components/__generated__/sendJoinRequest.mutation.generated';
import { YourCommunityGroupsDocument } from '../your/components/__generated__/yourGroups.generated';

export const ExploreCommunities = () => {
	const { loading, data, refetch } = usePublicCommunityGroupsQuery();
	const { refreshControl } = useRefreshControl(refetch);
	const [sendJoinRequest] = useSendJoinCommunityRequestMutation({
		refetchQueries: [PublicCommunityGroupsDocument, YourCommunityGroupsDocument],
	});

	const onSendJoinRequestPress = async (id: string) => {
		try {
			await sendJoinRequest({
				variables: {
					id,
				},
			});

			// @TODO - uncomment when we have a design for join requests
			// Toast.show({
			// 	type: 'success',
			// 	text1: t('community.join-request-sent'),
			// 	text2: t('community.your-request-has-been-sent-to-the-community-owner'),
			// });
		} catch (error) {
			console.error(error);

			if (error instanceof Error) {
				showErrorToUser(error);
			}
		}
	};

	if (loading) {
		return null;
	}

	return (
		<GroupsList
			refreshControl={refreshControl}
			groups={data?.publicGroups || []}
			onJoinPress={onSendJoinRequestPress}
		/>
	);
};
